export default __webpack_public_path__ + "static/media/Clementoni-little-puzzle-vehicles-1.f6e6b519.jpg";